import { oriasQueryKeys } from "@src/data/infoSocieteOrias/hook/oriasQuery.keys";
import { GatewayInfoSocieteOriasApi } from "@src/data/infoSocieteOrias/infoSocieteOrias.api";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useRelaunchOriasCheck(sirens: string[]) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      GatewayInfoSocieteOriasApi.relaunchInfoSocietesOrias(sirens),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: oriasQueryKeys.all });
    },
  });
}
